/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_References_Chip1_LabelInputs */



/**
* | output |
* | --- |
* | "What should I attach at project level?" |
*
* @param {Uno_Edu_Project_References_Chip1_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_references_chip1_label = /** @type {((inputs?: Uno_Edu_Project_References_Chip1_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_References_Chip1_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was sollte ich auf Projektebene anhängen?")
	return /** @type {LocalizedString} */ ("What should I attach at project level?")
});